import { render, staticRenderFns } from "./mSelect.vue?vue&type=template&id=382aedd9&scoped=true&"
import script from "./mSelect.vue?vue&type=script&lang=js&"
export * from "./mSelect.vue?vue&type=script&lang=js&"
import style0 from "./mSelect.vue?vue&type=style&index=0&id=382aedd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382aedd9",
  null
  
)

export default component.exports